let lastPathname: string | undefined;

/**
 * Call on every route change. A screen opened from the menu or a link starts at its top —
 * the browser keeps the scroll position of the screen you came from otherwise.
 * Going back keeps the restored position, and a query-only change (tab, filter) is still
 * the same screen.
 */
export function scrollToTopOnNewScreen(pathname: string, action: string): void {
  const isNewScreen = lastPathname !== undefined && lastPathname !== pathname;
  lastPathname = pathname;
  if (isNewScreen && action !== 'POP') window.scrollTo(0, 0);
}
